export enum FtReportSubject {
  Trainee,
  Trainer,
  Program
}
